import { api } from "../api/api";
import { appActions } from "../redux/reducers/app.ts";
import { leftSideActions } from "../redux/reducers/leftSideMenu.ts";
import store from "../redux/store.ts";

export const app = {
  changeActiveItem(active) {
    store.dispatch(leftSideActions.setActive(active));
  },

  changePageContentLoaderStatus(status) {
    store.dispatch(appActions.changePageContentLoaderStatus(status));
  },

  changePageModalLoader(status) {
    store.dispatch(appActions.changePageModalLoader(status));
  },

  changeTableContentLoaderStatus(status) {
    store.dispatch(appActions.changeTableContentLoaderStatus(status));
  },

  setAppProfile(body) {
    store.dispatch(appActions.setAppProfile(body));
  },

  setLinkedProfile(body) {
    store.dispatch(appActions.setLinkedProfile(body));
  },

  setNewData: async (url, data) => {
    const response = await api.setNewData(url, data);
    return response;
  },

  setSubscriptions(body) {
    store.dispatch(appActions.setSubscriptions(body));
  },

  // Example action click
  /*  appInit() {
    if (
      localStorage.getItem("campaignCreateName") &&
      localStorage.getItem("campaignCreateName").length > 0
    ) {
      campaignCreate.create(localStorage.getItem("campaignCreateName"));
    }
  }, */

  updateErrorRequest(body) {
    store.dispatch(appActions.updateErrorRequest(body));
  },
};
